module.exports = __webpack_public_path__ + "img/zscqlm.c5d8a9ba.png";